import { Validator } from "../util"

const LabelService = {
    almacen: (item) => {
        return `${item.alm_nombre} ${item.alm_tipo == 0 ? "" : ""} (${item.pry_nombre})`
    },
    empleado(item) {
        return item.emp_nombre_completo
    },
    empleadoProyecto(item) {
        return `${item.emp_nombre_completo} (${item.pry_nombre})`
    },
    producto(item) {
        return item.prv_nombre
    },
    productoAlmacenSerieStock(item) {
        return Validator.isNotNull(item.pal_numero_serie)
            ? `${item.prv_nombre} (NS: ${item.pal_numero_serie}) | ${item.pal_stock} ${item.unm_simbolo}`
            : `${item.prv_nombre} | ${item.pal_stock} ${item.unm_simbolo}`
    },
    productoAlmacenSerie(item) {
        return Validator.isNotNull(item.pal_numero_serie)
            ? `${item.prv_nombre} (NS: ${item.pal_numero_serie})`
            : `${item.prv_nombre}`
    },
    codigoOrdenCompra(item) {
        return item.ord_code
    }
}

export default LabelService